'use client';

import { PropsWithChildren } from 'react';
import { useSession } from 'next-auth/react';
import { ProtectedLayer } from '@/providers';
import { Shell } from '../shell';
import { Private } from './Private';

export default function PrivateGate({ children }: PropsWithChildren) {
  const { status } = useSession();
  const isAuthenticated = status === 'authenticated';

  return isAuthenticated ? (
    <Private>
      <ProtectedLayer>
        <Shell>{children}</Shell>
      </ProtectedLayer>
    </Private>
  ) : (
    <Shell>{children}</Shell>
  );
}
